import Sound from "react-sound";
import ClickSound from "assets/sounds/UI_SWITCH_Turn_On_04.mp3";

export const Click = () => {
  return <Sound autoLoad={true} url={ClickSound} playStatus={"PLAYING"} />;
};
